import React from 'react';

const ItemTitle = ({ item }) => {
	return (
		<h3 className="mb-1 font-bold text-base leading-snug">
			<span className="pr-2">
				{item.Name}{' '}
				{item.Item_Type[0].data.Name !== 'Document' &&
					item.Item_Type[0].data.Name}
			</span>

			{item.Size && <span>({item.Size[0].data.Name})</span>}
		</h3>
	);
};

export default ItemTitle;
